import { IonInput, IonSpinner } from '@ionic/react';
import { FieldConfig, useField } from 'formik';
import { ReactElement } from 'react';
import { IonItem } from '../../../../../components/ionic/IonItem';
import { WidgetLabel } from './widget-label';
import './widget.css';
import { WidgetProps } from './widget.types';

const WidgetLoading = (props: WidgetProps & FieldConfig): ReactElement => {
  const {
    label,
    description,
    ionItemProps,
    showDescription,
    subtitle,
    ...otherProps
  } = props;
  const classList: string[] = [
    'widget',
    'widget-loading',
    'transparent-background',
  ];

  const [_field, meta, _helper] = useField(otherProps as any);

  return (
    <IonItem
      className={classList.join(' ')}
      lines="full"
      {...ionItemProps}
      disabled={true}
    >
      <IonInput aria-label={label}>
        <div slot="label">
          <WidgetLabel
            label={label}
            description={description}
            showDescription={showDescription}
            error={meta.error}
            subtitle={subtitle}
          />
        </div>
      </IonInput>
      <IonSpinner slot="end" name="dots" className="ion-align-self-center" />
    </IonItem>
  );
};
export { WidgetLoading };
